var Ractive = require('ractive');
var component = module;

	component.exports ={
		onrender: function ( options ) {
			var self = this;
			self.on('doLogout', function () {
				var fUrl = Client.getUrl();
				if(fUrl.Hash=="logout"){
					self.cmd.Logout(self, function (oData) {
						if(oData.Status){
							setTimeout(function(){ 
								window.location.href = "#";
								window.location.reload();
							}, 400);
						}
        	});
				}
      });
			setInterval(function(){ 
				var fTTL= self.get("TTL");
				if(0<fTTL){
					fTTL--;
					self.set("TTL", fTTL);
				}
				if(1==fTTL){
					self.fire("doLogout");
				}				
			}, 1000);
		},
		data:function() { 
				return { 
					TTL: 10,
					formatCt: function(iValue, iTTL){
						return iValue.replace("{0}", iTTL);
					},
					Lng:SiteLng
				}
		}
 }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"style",f:"height: 120px;",t:13}]}," ",{p:[2,1,36],t:7,e:"div",f:[{t:4,f:[{p:[4,2,71],t:7,e:"div",m:[{n:"class",f:"alert alert-warning",t:13}],f:[{p:[5,3,108],t:7,e:"h1",f:[{t:3,x:{r:["formatCt","Lng.Page.Logoff.Title","TTL"],s:"_0(_1,_2)"},p:[5,7,112]}]}," ",{p:[6,3,163],t:7,e:"p",f:[{t:3,r:"Lng.Page.Logoff.Code",p:[6,6,166]}]}," ",{p:[7,3,200],t:7,e:"i",f:[{t:3,r:"Lng.Page.Logoff.Advise",p:[7,6,203]}]}]}],n:50,x:{r:["format"],s:"_0.IsUser()"},p:[3,2,44]},{t:4,n:51,f:[{p:[10,2,258],t:7,e:"div",m:[{n:"class",f:"alert alert-success",t:13}],f:[{p:[11,3,295],t:7,e:"h1",f:[{t:3,r:"Lng.Page.Logoff.Title",p:[11,7,299]}]}," ",{p:[12,3,335],t:7,e:"p",f:[{t:3,r:"Lng.Page.Logoff.Code",p:[12,6,338]}]}," ",{p:[13,3,372],t:7,e:"i",f:[{t:3,r:"Lng.Page.Logoff.Advise",p:[13,6,375]}]}]}],l:1}," ",{p:[16,2,429],t:7,e:"br"}," ",{p:[17,2,436],t:7,e:"a",m:[{n:"class",f:[{t:3,r:"Lng.Page.Logoff.Back.Class",p:[17,12,446]}],t:13},{n:"href",f:"javascript:history.go(-1);",t:13}],f:[{t:3,r:"Lng.Page.Logoff.Back.Text",p:[17,80,514]}]},"   ",{p:[18,2,564],t:7,e:"button",m:[{n:"class",f:[{t:3,r:"Lng.Page.Logoff.Login.Class",p:[18,17,579]}],t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doLogout\")]"}},t:70}],f:[{t:3,x:{r:["formatCt","Lng.Page.Logoff.Login.Text","TTL"],s:"_0(_1,_2)"},p:[18,86,648]}]}]}],e:{"_0(_1,_2)":function (_0,_1,_2){return(_0(_1,_2));},"_0.IsUser()":function (_0){return(_0.IsUser());},"[_0.fire(\"doLogout\")]":function (_0){return([_0.fire("doLogout")]);}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Logout.html
// module id = 24
// module chunks = 0